import {PolicyState, PolicyStore} from './policy.store';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {SignalEntityQuery} from '../../shared/state/signal-entity.store';
import {Documents, Policy} from '../../shared/models/policy.model';

@Injectable({ providedIn: 'root' })
export class PolicyQuery extends SignalEntityQuery<Policy, PolicyState> {
  constructor(protected store: PolicyStore ) {
    super(store);
  }

  getPolicyDocuments(): Observable<Documents[] | undefined> {
    return this.selectFirst().pipe(
      map(policy => policy?.documents)
    );
  }

  getPolicies(): Observable<any> {
    return this.selectAll();
  }
}
